// Material Dashboard 2 React layouts
import React from 'react'
import Icon from "@mui/material/Icon";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Inventory from "./layouts/inventory/index"
import LegacySignUp from "./layouts/authentication/sign-up/LegacySignUp";
import ForgetPassword from "./layouts/authentication/forget-password"
// @mui icons

import Outbounds from "./layouts/outbounds";
import ReportsPage from "./layouts/reports";
import BillingPage from "./layouts/myBilling";
import Account from "./layouts/system";
import SkeletonCard from "./components/MuiSkeleton";
import SkeletonCardWithNav from "./components/MuiSkeleton/SkeletonCardWithNav";
import Integration from "./layouts/integration";

const Dashboard = React.lazy(() => import('./layouts/dashboard/index'));

const PaymentPage  = React.lazy(()=>import("./layouts/system/payment"))
const CollectionRequisitionSearch  = React.lazy(()=>import("./layouts/myBilling/CollectionRequisition"));
const InvoiceManagementPage  = React.lazy(()=>import("./layouts/myBilling/invoice/InvoiceManagement"));
// const OtherFeeRequisitionPage  = React.lazy(()=>import("./layouts/myBilling/otherFee/OtherFeeRequisition"));
const MappingPage = React.lazy(() => import("./layouts/inventory/mapping")) ;
const Products = React.lazy(()=> import("./layouts/inventory/products"))
const InventoryStock = React.lazy(()=> import("./layouts/inventory/stockCheck"))
const KitManagement = React.lazy(()=> import("./layouts/inventory/kitManagement"))
const PackagingPage = React.lazy(()=> import("./layouts/inventory/packaging"))
const CustomerPage = React.lazy(()=> import("./layouts/customer"))
const InboundsPage = React.lazy(()=> import("./layouts/inbounds"))
const WholesalePage = React.lazy(()=> import("./layouts/outbounds/wholesale"))
const EcommercePage = React.lazy(() => import("./layouts/outbounds/ecommerce"))
const InventoryReportPage = React.lazy(()=>import("./layouts/reports/inventory"))
const FulfillmentReportPage = React.lazy(()=> import("./layouts/reports/fulfillment"))
const SalesReportPage = React.lazy(() => import("./layouts/reports/sales"))
const OnlineShopPage = React.lazy(() => import("./layouts/integration/onlineShop"))

const routes = [
    {
        type: "collapse",
        name: "Dashboard",
        key: "dashboard",
        icon: <Icon fontSize="small">dashboard</Icon>,
        route: "dashboard",
        isAuth: true,
        component: <Dashboard/>,
    },
    {
        type: "collapse",
        name: "Inventory",
        key: "inventory",
        icon: <Icon fontSize="small">inventory</Icon>,
        route: "/inventory",
        component: <Inventory/>,
        isAuth: true,
        children: [
            {
                type: "collapse",
                name: "Inventory Stock",
                key: "inventory_stock",
                icon: <Icon fontSize="small">inventory_2</Icon>,
                route: "/inventory_stock",
                component: <InventoryStock/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Product",
                key: "products",
                icon: <Icon fontSize="small">work</Icon>,
                route: "/products",
                component: <Products/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Kit Management",
                key: "kit_management",
                icon: <Icon fontSize="small">table_chart</Icon>,
                route: "/kit_management",
                component: <KitManagement/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Packaging",
                key: "packaging",
                icon: <Icon fontSize="small">table_view</Icon>,
                route: "/packaging",
                component: <PackagingPage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "SKU Mapping",
                key: "sku_mapping",
                icon: <Icon fontSize="small">device_hub</Icon>,
                route: "/sku_mapping",
                component: <MappingPage/>,
                isAuth: true,
            },
        ]
    },
    {
        type: "collapse",
        name: "Customer",
        key: "customer",
        icon: <Icon fontSize="small">person</Icon>,
        route: "/customer",
        component: <CustomerPage/>,
        isAuth: true,
    },
    {
        type: "collapse",
        name: "Inbounds",
        key: "inbounds",
        icon: <Icon fontSize="small">input</Icon>,
        route: "/inbounds",
        component: <InboundsPage/>,
        isAuth: true,
    },

    {
        type: "collapse",
        name: "Outbounds",
        key: "outbounds",
        icon: <Icon fontSize="small">output</Icon>,
        route: "/outbounds",
        component: <Outbounds/>,
        isAuth: true,
        children: [
            {
                type: "collapse",
                name: "Wholesale",
                key: "wholesale",
                icon: <Icon fontSize="small">warehouse</Icon>,
                route: "/wholesale",
                component: <WholesalePage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "E-commerce",
                key: "e-commerce",
                icon: <Icon fontSize="small">shopping_cart</Icon>,
                route: "/e-commerce",
                component: <EcommercePage/>,
                isAuth: true,
            }
        ]
    },
    {
        type: "collapse",
        name: "Integration",
        key: "integration",
        icon: <Icon fontSize="small">call_merge</Icon>,
        route: "/integration",
        component: <Integration/>,
        isAuth: true,
        children: [

            {
                type: "collapse",
                name: "Online Shop",
                key: "online_shop",
                icon: <Icon fontSize="small">store</Icon>,
                route: "/online_shop",
                component: <OnlineShopPage/>,
                isAuth: true,
            }
        ]
    },

    {
        type: "collapse",
        name: "Report",
        key: "reports",
        icon: <Icon fontSize="small">show_chart</Icon>,
        route: "/reports",
        component: <ReportsPage/>,
        isAuth: true,
        children: [
            // {
            //     type: "collapse",
            //     name: "Non Canadian Shipping",
            //     key: "non_canadian",
            //     icon: <Icon fontSize="small">assessment</Icon>,
            //     route: "/non_canadian",
            //     component: <NonCanadianShippingFeePage/>,
            //     isAuth: true,
            // },
            {
                type: "collapse",
                name: "Inventory Report",
                key: "inventory_reports",
                icon: <Icon fontSize="small">inventory</Icon>,
                route: "/inventory_reports",
                component: <InventoryReportPage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Fulfillment Report",
                key: "fulfillment_reports",
                icon: <Icon fontSize="small">fact_check</Icon>,
                route: "/fulfillment_reports",
                component: <FulfillmentReportPage/>,
                isAuth: true,
            },
            {
                type: "collapse",
                name: "Sales Report",
                key: "sales_reports",
                icon: <Icon fontSize="small">monetization_on</Icon>,
                route: "/sales_reports",
                component: <SalesReportPage/>,
                isAuth: true,
            }
        ]
    },
    {
        type: "collapse",
        name: "Billing",
        key: "billing",
        icon: <Icon fontSize="small">receipt_long</Icon>,
        route: "/billing",
        isAuth: true,
        component: <BillingPage/>,
        children: [
            // {
            //     type: "collapse",
            //     name: "Other Fee Requisition",
            //     key: "other_fee",
            //     icon: <Icon fontSize="small">payments</Icon>,
            //     route: "/other_fee",
            //     component: <OtherFeeRequisitionPage/>,
            //     isAuth: true,
            //
            // },
            {
                type: "collapse",
                name: "Collection Requisition",
                key: "collection_requisition",
                icon: <Icon fontSize="small">inventory</Icon>,
                route: "/collection_requisition",
                component: <CollectionRequisitionSearch/>,
                isAuth: true,

            },
            {
                type: "collapse",
                name: "Invoice Management",
                key: "invoice_management",
                icon: <Icon fontSize="small">receipt_outlined</Icon>,
                route: "/invoice_management",
                component: <InvoiceManagementPage/>,
                isAuth: true,
            }
            ]
    },

    // {
    //     type: "collapse",
    //     name: "Billing2",
    //     key: "billing2",
    //     icon: <Icon fontSize="small">receipt_long</Icon>,
    //     route: "/billing2",
    //     isAuth: true,
    //     component: <Billing/>,
    // },
    // {
    //     type: "collapse",
    //     name: "System",
    //     key: "system",
    //     icon: <Icon fontSize="small">settings</Icon>,
    //     route: "/system",
    //     isAuth: true,
    //     component: <Account/>,
    //     children: [
    //         {
    //             type: "collapse",
    //             name: "profile",
    //             key: "profile",
    //             icon: <Icon fontSize="small">manage_accounts</Icon>,
    //             route: "/profile",
    //             component: <SkeletonCardWithNav/>,
    //             isAuth: true,
    //         }
    //         ]
    // },
    {
        type: "collapse",
        name: "Account",
        key: "account",
        icon: <Icon fontSize="small">manage_accounts</Icon>,
        route: "/account",
        isAuth: true,
        component: <Profile/>,
    },
    {
        type: "collapse",
        name: "Sign In",
        key: "sign-in",
        isAuth: false,
        icon: <Icon fontSize="small">login</Icon>,
        route: "/authentication/sign-in",
        component: <SignIn/>,
    },
    {
        type: "collapse",
        name: "Sign Up",
        key: "sign-up",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/authentication/sign-up",
        isAuth: false,
        component: <SignUp/>,
    },
    {
        type: "collapse",
        name: "Legacy Sign Up",
        key: "legacy-sign-up",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/authentication/legacy-sign-up",
        isAuth: false,
        component: <LegacySignUp/>,
    },

    {
        type: "collapse",
        name: "Sign Up",
        key: "forget-password",
        icon: <Icon fontSize="small">assignment</Icon>,
        route: "/authentication/forget_password",
        isAuth: false,
        component: <ForgetPassword/>,
    },
];

export default routes;
